import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Fetchable, Paginated } from "../../interfaces";
import { Officer } from "../../interfaces/Officer";

export interface OfficerState {
  allOfficers: Partial<Fetchable<Paginated<Officer>>>;
  officer: Partial<Fetchable<Officer>>;
  createdOfficer: Partial<Fetchable<Officer>>;
  updatedOfficer: Partial<Fetchable<Officer>>;
  deletedOfficer: Partial<Fetchable<Officer>>;
  passwordReset: Partial<Fetchable<boolean>>;
}

const initialState: OfficerState = {
  allOfficers: {},
  officer: {},
  createdOfficer: {},
  updatedOfficer: {},
  deletedOfficer: {},
  passwordReset: {},
};

export const officerSlice = createSlice({
  name: "officer",
  initialState,
  reducers: {
    setError: (
      state,
      action: PayloadAction<{
        fetchableProp: keyof OfficerState;
        error: string;
      }>
    ) => {
      state[action.payload.fetchableProp].error = action.payload.error;
    },
    clear: (state, action: PayloadAction<keyof OfficerState>) => {
      state[action.payload] = {};
    },
    setLoader: (
      state,
      action: PayloadAction<{
        fetchableProp: keyof OfficerState;
        isLoading: boolean;
      }>
    ) => {
      state[action.payload.fetchableProp].isLoading = action.payload.isLoading;
    },
    // PAGINATED GET
    setPaginatedOfficers: (
      state,
      action: PayloadAction<Paginated<Officer>>
    ) => {
      state.allOfficers.data = action.payload;
    },
    // GET
    setOfficer: (state, action: PayloadAction<Officer>) => {
      state.officer.data = action.payload;
      state.officer.error = undefined;
    },
    // CREATE
    createOfficer: (state, action: PayloadAction<Officer>) => {
      state.createdOfficer.data = action.payload;
      state.createdOfficer.error = undefined;
    },
    // UPDATE
    updateOfficer: (state, action: PayloadAction<Officer>) => {
      state.updatedOfficer.data = action.payload;
      state.updatedOfficer.error = undefined;
    },
    // DELETE
    deleteOfficer: (state, action: PayloadAction<Officer>) => {
      state.deletedOfficer.data = action.payload;
      state.deletedOfficer.error = undefined;
    },
    // RESET PASSWORD
    resetPassword: (state, action: PayloadAction<boolean>) => {
      state.passwordReset.data = action.payload;
      state.passwordReset.error = undefined;
    },
  },
});

const actions = { ...officerSlice.actions };

export { actions };
export default officerSlice.reducer;
